"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var MenuS = _interopRequireWildcard(require("./MenuStyles"));
var _helpers = require("../../helpers");
var _getContentForMatching = require("./getContentForMatching");
var _hooks = require("../../hooks");
var _excluded = ["icon", "set", "text", "isActive", "isDisabled", "isHighlighted", "searchValue"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Name of the Icon; should exist in Icons */
  icon: _propTypes["default"].string.isRequired,
  /** The icon set name, Is optional */
  set: _propTypes["default"].string,
  /** Text Displayed next to the icon */
  text: _propTypes["default"].string,
  /** State for the menu */
  isActive: _propTypes["default"].bool,
  /** Disabled state for the menu */
  isDisabled: _propTypes["default"].bool,
  /** Menu item has been found by Search field */
  isHighlighted: _propTypes["default"].bool,
  /** Search term that is used for highlighting the text */
  searchValue: _propTypes["default"].string
};
exports.propTypes = propTypes;
var MenuItem = function MenuItem(_ref) {
  var icon = _ref.icon,
    set = _ref.set,
    text = _ref.text,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    isHighlighted = _ref.isHighlighted,
    searchValue = _ref.searchValue,
    other = _objectWithoutProperties(_ref, _excluded);
  var ref = (0, _hooks.useGoToHighlighted)(isHighlighted, searchValue);
  var className = (0, _helpers.getClassNameFromProps)({
    isActive: isActive,
    isDisabled: isDisabled,
    isHighlighted: isHighlighted
  });
  return /*#__PURE__*/_react["default"].createElement(MenuS.ItemWrapper, {
    isDisabled: isDisabled
  }, /*#__PURE__*/_react["default"].createElement(MenuS.Item, _extends({
    ref: ref,
    className: className,
    activeClassName: "is-active"
  }, other), /*#__PURE__*/_react["default"].createElement(MenuS.Icon, {
    name: icon,
    set: set
  }), text && /*#__PURE__*/_react["default"].createElement(MenuS.ItemText, null, searchValue && isHighlighted ? (0, _getContentForMatching.getContentForMatching)(text, searchValue) : text)));
};
MenuItem.propTypes = propTypes;
var _default = MenuItem;
exports["default"] = _default;